// extracted by mini-css-extract-plugin
module.exports = {"container":"DiscountPanel_container__2056D","formContainer":"DiscountPanel_formContainer__3I9Qk","buttonContainer":"DiscountPanel_buttonContainer__2rkP-"};